export default function Toast({ 
  message, 
  onClose,
  id
}: { 
  message: string, 
  onClose: () => void,
  id?: number
}) {
    return (
        <div className={`absolute top-0 right-0 w-[20rem] shadow-lg px-4 py-3 rounded-lg z-50 
          bg-[#F2FFF7] dark:bg-[#0A3D1E] 
          border border-[#0DB04E] dark:border-[#0DB04E] 
          flex justify-between transition-colors duration-200`}
          id={id?.toString()}
        >
            <div className={`flex`}>
                <svg className='size-5' width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.275 14.525L15.4437 8.35625L14.2188 7.13125L9.275 12.075L6.78125 9.58125L5.55625 10.8062L9.275 14.525ZM10.5 19.25C9.28958 19.25 8.15208 19.0203 7.0875 18.5609C6.02292 18.1016 5.09687 17.4781 4.30938 16.6906C3.52188 15.9031 2.89844 14.9771 2.43906 13.9125C1.97969 12.8479 1.75 11.7104 1.75 10.5C1.75 9.28958 1.97969 8.15208 2.43906 7.0875C2.89844 6.02292 3.52188 5.09687 4.30938 4.30938C5.09687 3.52188 6.02292 2.89844 7.0875 2.43906C8.15208 1.97969 9.28958 1.75 10.5 1.75C11.7104 1.75 12.8479 1.97969 13.9125 2.43906C14.9771 2.89844 15.9031 3.52188 16.6906 4.30938C17.4781 5.09687 18.1016 6.02292 18.5609 7.0875C19.0203 8.15208 19.25 9.28958 19.25 10.5C19.25 11.7104 19.0203 12.8479 18.5609 13.9125C18.1016 14.9771 17.4781 15.9031 16.6906 16.6906C15.9031 17.4781 14.9771 18.1016 13.9125 18.5609C12.8479 19.0203 11.7104 19.25 10.5 19.25Z" fill="#0DB04E"/>
                </svg>
                <div className='flex flex-col ml-2'>
                    <p className={`text-[#1B2238] dark:text-white text-sm font-semibold flex items-center`}>{message}</p>
                </div>
            </div> 
            <svg className='size-5 cursor-pointer' onClick={onClose} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.6 16.625L4.375 15.4L9.275 10.5L4.375 5.6L5.6 4.375L10.5 9.275L15.4 4.375L16.625 5.6L11.725 10.5L16.625 15.4L15.4 16.625L10.5 11.725L5.6 16.625Z" fill="#ABB1C3"/>
            </svg>
        </div>
    );
}